var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderProductViewYourDataHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3377 15.6523C35.8845 16.7462 35.4412 18.0762 34.3474 18.6232L21.1786 25.4998L34.3474 32.3764C35.4412 32.9233 35.8845 34.2534 35.3377 35.3472C34.7908 36.441 33.4607 36.8843 32.3669 36.3375L13.9145 27.4803C13.1644 27.1052 12.6905 26.3385 12.6905 25.4998C12.6905 24.6611 13.1644 23.8944 13.9145 23.5193L32.3669 14.6621C33.4607 14.1152 34.7908 14.5586 35.3377 15.6523Z",
    fill: "#00726E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 25.5C22.2857 29.1688 19.3116 32.1429 15.6429 32.1429C11.9741 32.1429 9 29.1688 9 25.5C9 21.8313 11.9741 18.8572 15.6429 18.8572C19.3116 18.8572 22.2857 21.8313 22.2857 25.5Z",
    fill: "#66BCB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16.6429C40 20.3116 37.0259 23.2857 33.3572 23.2857C29.6884 23.2857 26.7143 20.3116 26.7143 16.6429C26.7143 12.9741 29.6884 10 33.3572 10C37.0259 10 40 12.9741 40 16.6429Z",
    fill: "#66BCB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34.3572C40 38.0259 37.0259 41 33.3572 41C29.6884 41 26.7143 38.0259 26.7143 34.3572C26.7143 30.6884 29.6884 27.7143 33.3572 27.7143C37.0259 27.7143 40 30.6884 40 34.3572Z",
    fill: "#66BCB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProductViewYourDataHub);
export default __webpack_public_path__ + "static/media/HeaderProductViewYourDataHub.f6012e8145fbe30632561c6c64a7390e.svg";
export { ForwardRef as ReactComponent };